<app-loader></app-loader>
<router-outlet></router-outlet>

<!-- Force change password modal: shown on every page when mustChangePassword is true; cannot be closed until password is changed -->
<div class="force-change-overlay" *ngIf="showForceChangeModal">
  <div class="force-change-modal" (click)="$event.stopPropagation()">
    <h2 class="force-change-title">Change your password</h2>
    <p class="force-change-desc">You must set a new password before you can continue. This window cannot be closed until you change your password.</p>
    <form [formGroup]="forceChangeForm" (ngSubmit)="onSubmitForceChange()">
      <div class="mb-3">
        <label class="form-label">Current password</label>
        <input type="password" class="form-control" formControlName="currentPassword" placeholder="Current password" />
      </div>
      <div class="mb-3">
        <label class="form-label">New password</label>
        <input type="password" class="form-control" formControlName="password" placeholder="New password (min 8 chars, upper, lower, number, special)" />
      </div>
      <div class="mb-3">
        <label class="form-label">Confirm new password</label>
        <input type="password" class="form-control" formControlName="confirmPassword" placeholder="Confirm new password" />
      </div>
      <p class="text-danger small mb-2" *ngIf="forceChangeError">{{ forceChangeError }}</p>
      <div class="force-change-actions">
        <button type="submit" class="btn force-change-submit-btn" [disabled]="forceChangeSubmitting">
          {{ forceChangeSubmitting ? 'Changing...' : 'Change password' }}
        </button>
        <button type="button" class="btn btn-outline-secondary force-change-logout-btn" (click)="onLogoutFromForceChange()">
          Logout
        </button>
      </div>
    </form>
  </div>
</div>